<template>
  <!-- Denne burde se ut som footeren på getacademy.no -->
  <div>
    <div class="footer">
      <div class="footer-content">
        <div>
          <p>Nedre Fritzøegate 2, 3264 Larvik / Plateverkstedet</p>
          <p>post@getacademy.no</p>
          <p>45485922</p>
        </div>
        <div>
          <!-- <p>
            <router-link to="/faq">FAQ</router-link>
          </p> -->
          <p>
            <router-link to="/personvern"
              >Informasjon om personvern</router-link
            >
          </p>
          <p>
            <LinkButton
              href="https://forms.gle/r5aK33LX8SjcAuDs5"
              target="_blank"
              text="Gi tilbakemelding!"
            />
          </p>
          <p v-if="isAdmin">
            For admins:
            <router-link :to="{ name: 'AdminPanel' }">AdminPanel</router-link> /
            <router-link :to="{ name: 'CandidateSearch' }"
              >Søkeside</router-link
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isAdmin } from "@/auth/adminGuard.js";

export default {
  name: "Footer",
  computed: {
    isAdmin() {
      return isAdmin(this.$auth.user.email);
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  margin-top: 30px;
  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.2);
  color: var(--dark-color);
  // text-align: center;
  background-color: var(--white-color);
}

.footer-content {
  width: var(--content-width);
  margin: auto;
  display: flex;

  & > div {
    margin: 0;
    padding: 1em;
    width: 50%;
    &:last-child {
      text-align: right;
    }
  }
}

p {
  margin: 1em 0;
}

a {
  color: var(--primary-color);
}

.button {
  color: white;
}

@media only screen and (max-width: 856px) {
  .footer-content {
    flex-direction: column;
    max-width: 100%;
    align-content: flex-end;

    & > div {
      padding: 0 1em;
      width: 90%;
       &:last-child {
      text-align: left;
    }
    }
  }
}
</style>